export const INITIAL_VALUES = {
  date_start: '',
  date_finish: '',
  organizer: null,
};
